/**
 * The app's one rule for asking again after a failed read (B109).
 *
 * A refusal for too many requests (429) is the server asking the app to wait,
 * and a refused hit still counts against the limit, so asking again only
 * keeps the limit full. Every other failure is asked again as many times as
 * QUERY_RETRY_COUNT says, as before.
 *
 * Used by: queryClient (the default for every query).
 *
 * @module queryRetry
 */

import axios from 'axios';

/**
 * Builds React Query's retry rule: never for a 429, otherwise up to
 * maxRetries times.
 *
 * @param maxRetries - How many times a failed query is asked again (QUERY_RETRY_COUNT).
 * @returns The rule: given the failures so far and the last error, true to ask again.
 */
export function retryRule(maxRetries: number): (failureCount: number, error: Error) => boolean {
  return (failureCount, error) => {
    if (axios.isAxiosError(error) && error.response?.status === 429) return false;
    return failureCount < maxRetries;
  };
}
